import React from 'react';
import { ImagePlaceholder, SectionWrapper, CTAButton, StarRating } from './ui';
import { CheckCircle2 } from 'lucide-react';
export const ProductReveal = () => {
  return <SectionWrapper className="py-12 bg-primary text-white" isWide={true} data-id="element-159">
      <div className="max-w-[720px] mx-auto text-center mb-10" data-id="element-160">
        <h2 className="text-3xl md:text-4xl font-serif leading-tight text-background" data-id="element-161">
          The Fourth Layer of Tick Defense Has Been Quietly Used in Europe for
          15+ Years — and Almost No American Parent Has Heard of It.
        </h2>
      </div>

      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-10" data-id="element-162">
        <div className="w-full md:w-1/2" data-id="element-163">
          <div className="w-full aspect-square overflow-hidden rounded-sm border border-white/20" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/vuWnABtJ5zvFWGGUu3hjek/hCQpbIJzotOlXCSYZxe1E_tMgrDCMY.webp" alt="LEVANCE ultrasonic tick repellent device, triangular and about the size of a guitar pick" className="w-full h-full object-cover" data-id="element-165" />
          </div>
        </div>
        <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-166">
          <CTAButton className="w-full sm:w-auto text-lg py-5 px-10 mb-6" data-id="element-167">
            CHECK AVAILABILITY →
          </CTAButton>
        </div>
      </div>
    </SectionWrapper>;
};
export const RatingSummary = () => {
  return <SectionWrapper className="py-12" data-id="element-168">
      <div className="bg-white border border-sage p-6 md:p-8 rounded-sm shadow-sm max-w-2xl mx-auto" data-id="element-169">
        <div className="flex flex-col md:flex-row gap-8 items-center md:items-start" data-id="element-170">
          <div className="flex flex-col items-center md:items-start md:w-1/3" data-id="element-171">
            <div className="text-5xl font-serif font-bold text-primary mb-2" data-id="element-172">
              4.8
            </div>
            <StarRating rating={4.8} className="mb-2" data-id="element-173" />
            <div className="text-sm text-foreground/70 font-medium" data-id="element-174">
              out of 5 — 7,341 ratings
            </div>
          </div>

          <div className="w-full md:w-2/3 flex flex-col gap-2" data-id="element-175">
            {[{
            stars: 5,
            pct: 81
          }, {
            stars: 4,
            pct: 13
          }, {
            stars: 3,
            pct: 4
          }, {
            stars: 2,
            pct: 1
          }, {
            stars: 1,
            pct: 1
          }].map(row => <div key={row.stars} className="flex items-center text-sm" data-id="element-176">
                <span className="w-16 text-foreground/80" data-id="element-177">
                  {row.stars} stars
                </span>
                <div className="flex-1 h-2 bg-sage/50 mx-3 rounded-full overflow-hidden" data-id="element-178">
                  <div className="h-full bg-accent" style={{
                width: `${row.pct}%`
              }} data-id="element-179"></div>
                </div>
                <span className="w-8 text-right text-foreground/60" data-id="element-180">
                  {row.pct}%
                </span>
              </div>)}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-sage/50 grid grid-cols-2 gap-4 text-sm" data-id="element-181">
          <div className="flex justify-between items-center" data-id="element-182">
            <span className="font-medium" data-id="element-183">Ease of use</span>
            <div className="flex items-center gap-2" data-id="element-184">
              <StarRating rating={5} className="scale-75 origin-right" data-id="element-185" /> 4.9
            </div>
          </div>
          <div className="flex justify-between items-center" data-id="element-186">
            <span className="font-medium" data-id="element-187">Build quality</span>
            <div className="flex items-center gap-2" data-id="element-188">
              <StarRating rating={5} className="scale-75 origin-right" data-id="element-189" /> 4.7
            </div>
          </div>
          <div className="flex justify-between items-center" data-id="element-190">
            <span className="font-medium" data-id="element-191">Battery life</span>
            <div className="flex items-center gap-2" data-id="element-192">
              <StarRating rating={5} className="scale-75 origin-right" data-id="element-193" /> 4.8
            </div>
          </div>
          <div className="flex justify-between items-center" data-id="element-194">
            <span className="font-medium" data-id="element-195">Peace of mind</span>
            <div className="flex items-center gap-2" data-id="element-196">
              <StarRating rating={5} className="scale-75 origin-right" data-id="element-197" /> 4.9
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};
export const ReviewCard = () => {
  return <SectionWrapper className="py-6" data-id="element-198">
      <div className="bg-sage/20 border border-sage p-6 md:p-8 rounded-sm" data-id="element-199">
        <StarRating rating={5} className="mb-4" data-id="element-200" />
        <h3 className="text-xl md:text-2xl font-serif font-bold text-primary mb-6 leading-tight" data-id="element-201">
          "The mental quiet is what I didn't expect."
        </h3>

        <div className="flex items-center gap-4 mb-6 pb-6 border-b border-sage/50" data-id="element-202">
          <div className="w-12 h-12 rounded-full overflow-hidden border border-sage shrink-0" data-id="element-203">
            <img src="https://cdn.magicpatterns.com/uploads/okPcikpJg3cF4xJd1UG4ek/8086344c-a14d-46af-97a9-c61162c3e832.png" alt="Rachel M." className="w-full h-full object-cover" data-id="element-204" />
          </div>
          <div data-id="element-205">
            <div className="font-bold text-foreground" data-id="element-206">
              Rachel M. — Fairfield, CT
            </div>
            <div className="text-sm text-primary font-medium flex items-center mt-0.5" data-id="element-207">
              <CheckCircle2 className="w-3.5 h-3.5 mr-1" data-id="element-208" /> Verified Buyer
            </div>
          </div>
        </div>

        <p className="text-[16px] leading-[1.6] text-foreground/90" data-id="element-209">
          I bought four. One for each kid's backpack, one for the dog's harness,
          one for my husband's golf bag. I am the mom on the soccer sideline who
          comments "tick check!!" on every photo. I have a science brain and I
          read the Haller's organ research before I bought. What sold me wasn't
          the science — it was that the founder said outright "this works WITH
          permethrin, not instead of it." Six weeks in, my son's cleats still
          get the picaridin in the morning. My daughter still wears the Insect
          Shield. The bedtime comb still happens.{' '}
          <strong className="font-bold" data-id="element-210">
            But the between moments — soccer at 11 a.m., the dog walk at dusk,
            the backyard between getting home and dinner — those used to be the
            gaps I lay awake about. Now they're covered.
          </strong>{' '}
          I'm not saying I've stopped checking. I'm saying I stopped
          catastrophizing. That alone was worth four units.
        </p>
      </div>
    </SectionWrapper>;
};
export const HallerExplainer = () => {
  return <SectionWrapper className="py-10" data-id="element-211">
      <div className="mb-8" data-id="element-212">
        <div className="w-full aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-213">
          <img src="https://cdn.magicpatterns.com/uploads/cz6XYTpM8ueAZqk4CxTjQE/228788ed-b591-47be-9a11-542d78803226.png" alt="Scientific illustration of a questing tick on a blade of grass, with labeled Haller's organ and ultrasonic disruption waves emanating from its front legs" className="w-full h-full object-cover" data-id="element-214" />
        </div>
      </div>

      <div className="space-y-6 text-[17px] leading-[1.6] text-foreground/90" data-id="element-215">
        <p data-id="element-216">
          Ticks don't see the way you do. They are nearly blind. What they have
          instead is a tiny, exquisitely sensitive sensor on their front legs
          called Haller's organ — and this is where the entire story of modern
          tick defense gets interesting.
        </p>
        <p data-id="element-217">
          Haller's organ reads the world through vibration, heat, exhaled CO₂,
          humidity, and a very narrow band of ambient frequencies. It's how a
          tick on a blade of grass — or a Lone Star tick actively quartering
          toward your daughter on the soccer field — knows that a warm-blooded
          mammal has entered its airspace. It's how it decides whether the
          passing target is worth latching onto. Haller's organ is the tick's
          entire targeting system. Without it, the tick is a blind insect on a
          leaf. With it, the tick is a guided projectile.
        </p>
        <p data-id="element-218">
          Here's the part that almost no American consumer has been told:
          Haller's organ is also the tick's single greatest vulnerability. When
          a specific ultrasonic frequency band — between roughly 9 and 21 kHz,
          completely inaudible to humans, dogs, and cats — is introduced into
          the tick's sensory field, the organ effectively short-circuits.
        </p>

        <div className="text-center py-6" data-id="element-219">
          <span className="text-2xl font-serif text-accent font-bold italic" data-id="element-220">
            "sensory static"
          </span>
        </div>

        <p data-id="element-221">
          Researchers describe it as "sensory static." The instruments go
          haywire. The mammal it was hunting no longer reads as prey. The tick
          disengages and looks elsewhere. You don't kill it. You don't poison
          the environment. You don't put anything on your child's skin. You make
          your family invisible to the part of the tick that decides who to
          bite.
        </p>
      </div>

      <div className="mt-10" data-id="element-222">
        <div className="w-full aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-223">
          <img src="https://cdn.magicpatterns.com/uploads/szDSkRogrBx1Rjkzmjo7CV/13e0b188-3613-4445-a8eb-187aa30c2c55.png" alt="A mother sitting relaxed on a back deck at golden hour, holding iced tea, finally at peace" className="w-full h-full object-cover" data-id="element-224" />
        </div>
      </div>
    </SectionWrapper>;
};
export const TwoStepSolution = () => {
  return <SectionWrapper className="py-10" data-id="element-225">
      <p className="text-[17px] leading-[1.6] text-foreground/90 mb-8 font-medium" data-id="element-226">
        So the solution comes down to two things — and they're simpler than the
        marketing of this category has ever made them sound:
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-227">
        <div className="bg-sage/30 border border-sage p-6 rounded-sm" data-id="element-228">
          <h3 className="font-serif text-xl font-bold text-primary mb-3 flex items-center gap-3" data-id="element-229">
            <span className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-sans shrink-0" data-id="element-230">
              1
            </span>
            Keep doing what already works.
          </h3>
          <p className="text-[16px] leading-[1.6] text-foreground/80" data-id="element-231">
            Permethrin on the hiking pants. Picaridin on the exposed ankles
            before soccer. The bedtime tick check. The yard treatment. None of
            that goes away. The CDC, ILADS, and every credible voice in tick
            research agrees: no single defense is one hundred percent. Layer up.
          </p>
        </div>

        <div className="bg-sage/30 border border-sage p-6 rounded-sm" data-id="element-232">
          <h3 className="font-serif text-xl font-bold text-primary mb-3 flex items-center gap-3" data-id="element-233">
            <span className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-sans shrink-0" data-id="element-234">
              2
            </span>
            Close the gap with the layer that's been missing.
          </h3>
          <p className="text-[16px] leading-[1.6] text-foreground/80" data-id="element-235">
            The exposed skin between the cuff and the sock. The 90-minute soccer
            game two hours after the morning spray. The dog who can't be
            sprayed. The dusk on the back deck when nobody bothered to suit up.
            This is where the chemical playbook fails — and it's exactly where a
            non-chemical, sensory-disruption layer was engineered to live.
          </p>
        </div>
      </div>

      <p className="text-[17px] leading-[1.6] text-foreground/90" data-id="element-236">
        For years, the only people running this play were European
        veterinarians. The big American chemical brands had no incentive to tell
        you about it — there's no spray to refill, no concentrate to
        reformulate, no annual repurchase cycle. So the research sat there.
        Until a dad whose six-year-old failed an alpha-gal panel decided it was
        time to bring it across the Atlantic, redesigned for a human family that
        lives outside.
      </p>
    </SectionWrapper>;
};
export const SpecBlock = () => {
  return <SectionWrapper className="py-10" data-id="element-237">
      <div className="mb-8" data-id="element-238">
        <div className="w-full aspect-[16/9] overflow-hidden rounded-sm border border-sage" data-id="element-239">
          <img src="https://cdn.magicpatterns.com/uploads/5Ad5oirYdyiyp74zqyDVQj/a5662070-17a9-4721-81fe-e5ae63a8372a.png" alt="LEVANCE ultrasonic tick repellent device in black with USB-C cable and carabiner clip on a concrete surface" className="w-full h-full object-cover" data-id="element-240" />
        </div>
      </div>

      <h2 className="text-3xl font-serif text-primary font-bold mb-6" data-id="element-241">
        Not Chemistry — Physics
      </h2>

      <div className="space-y-6 text-[17px] leading-[1.6] text-foreground/90 mb-10" data-id="element-242">
        <p data-id="element-243">
          LEVANCE doesn't use a blend of ingredients. It doesn't use ingredients
          at all. It uses physics.
        </p>
        <p data-id="element-244">
          Inside the 11-gram, guitar-pick-sized housing is a precision
          ultrasonic emitter calibrated to a wide-band frequency between
          approximately 9 and 21 kHz — the exact range that disrupts the
          Haller's organ of ticks, including the Lone Star tick driving the
          alpha-gal epidemic, while sitting above the comfortable hearing range
          of human adults and outside the sensitivity peaks of dogs and cats.
        </p>
        <p data-id="element-245">
          This calibration didn't come out of a guess. It came from eighteen
          months of conversations with veterinary researchers in Sweden and
          Hungary who have been quietly observing this principle in working-dog
          populations across Scandinavia and Central Europe since the early
          2010s. Their data, their field reports, their frequency curves —
          translated, redesigned, and rebuilt for a human form factor that a
          six-year-old can clip onto her own backpack.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-246">
        {[{
        stat: '11g',
        label: 'Device Weight'
      }, {
        stat: 'Multi-Day',
        label: 'Battery Life'
      }, {
        stat: '1–2 hrs',
        label: 'USB-C Charge'
      }, {
        stat: '1 Button',
        label: 'Operation'
      }].map((item, i) => <div key={i} className="bg-sage/20 border border-sage p-4 text-center rounded-sm flex flex-col justify-center min-h-[120px]" data-id="element-247">
            <div className="text-2xl md:text-3xl font-serif font-bold text-accent mb-2" data-id="element-248">
              {item.stat}
            </div>
            <div className="text-sm font-bold text-primary leading-tight" data-id="element-249">
              {item.label}
            </div>
          </div>)}
      </div>

      <p className="text-[17px] leading-[1.6] text-foreground/90" data-id="element-250">
        It runs continuously for days on a single 1-to-2-hour USB-C charge. It
        has one button. No refills. No chemicals. No scent. No reapplication. No
        melting watch bands. No "did I get the back of her neck?" The reason
        you've never heard of this in the American consumer market is not
        because it's new. It's because nobody built the version for your family
        until now.
      </p>
    </SectionWrapper>;
};
export const IntroducingBlock = () => {
  return <SectionWrapper className="py-12 bg-white border-y border-sage/50" data-id="element-251">
      <h2 className="text-3xl md:text-4xl font-serif text-primary font-bold mb-4 text-center" data-id="element-252">
        Introducing LEVANCE™
      </h2>
      <p className="text-lg text-center text-foreground/80 font-medium mb-8 max-w-2xl mx-auto" data-id="element-253">
        The first ultrasonic tick-deterrence wearable designed, marketed, and
        engineered for the modern family — not as an afterthought to a pet
        product line.
      </p>

      <div className="flex justify-center mb-10" data-id="element-254">
        <div className="inline-flex items-center bg-primary/10 text-primary font-bold px-4 py-2 rounded-full text-sm" data-id="element-255">
          <CheckCircle2 className="w-4 h-4 mr-2" data-id="element-256" />
          Over 30,000 families protected
        </div>
      </div>

      <p className="text-[17px] leading-[1.6] text-foreground/90 mb-10" data-id="element-257">
        Over 30,000 families across the Lyme belt and Lone Star expansion zones
        have already clipped one onto a backpack strap, a soccer bag, a dog
        harness, a belt loop, a hunting pack. They include parents who grew up
        running barefoot in towns that no longer feel safe to. They include
        hunters who've pulled more ticks off whitetails this season than in
        forty-six years of hunting. They include mothers whose cousins have
        alpha-gal and who don't intend to lose another family member to a single
        bite.
      </p>

      <ul className="space-y-6 mb-10" data-id="element-258">
        <li className="flex items-start gap-4" data-id="element-259">
          <span className="text-2xl shrink-0" data-id="element-260">👤</span>
          <p className="text-[16px] leading-[1.6]" data-id="element-261">
            <strong className="font-bold" data-id="element-262">Built for humans first</strong> — not
            relabeled pet gear.
          </p>
        </li>
        <li className="flex items-start gap-4" data-id="element-263">
          <span className="text-2xl shrink-0" data-id="element-264">🎯</span>
          <p className="text-[16px] leading-[1.6]" data-id="element-265">
            <strong className="font-bold" data-id="element-266">Targets the Lone Star tick</strong> —
            the tick driving the alpha-gal crisis — not just the deer tick of
            1995.
          </p>
        </li>
        <li className="flex items-start gap-4" data-id="element-267">
          <span className="text-2xl shrink-0" data-id="element-268">🛡️</span>
          <p className="text-[16px] leading-[1.6]" data-id="element-269">
            <strong className="font-bold" data-id="element-270">
              Works WITH your existing protection
            </strong>{' '}
            — permethrin, picaridin, Insect Shield, tick checks. It doesn't
            replace anything. It closes the gap.
          </p>
        </li>
        <li className="flex items-start gap-4" data-id="element-271">
          <span className="text-2xl shrink-0" data-id="element-272">🚫</span>
          <p className="text-[16px] leading-[1.6]" data-id="element-273">
            <strong className="font-bold" data-id="element-274">
              Zero chemicals, zero scent, zero refills, zero reapplication.
            </strong>{' '}
            Clip and forget.
          </p>
        </li>
        <li className="flex items-start gap-4" data-id="element-275">
          <span className="text-2xl shrink-0" data-id="element-276">❤️</span>
          <p className="text-[16px] leading-[1.6]" data-id="element-277">
            <strong className="font-bold" data-id="element-278">
              Founded by a father whose six-year-old daughter is alpha-gal
              positive.
            </strong>{' '}
            This is not a white-label drop-shipper. This is a guy who lost
            something and built the thing he wishes had existed.
          </p>
        </li>
      </ul>

      <div className="bg-background border border-sage p-4 text-center rounded-sm mb-8" data-id="element-279">
        <p className="font-medium text-foreground/80" data-id="element-280">
          Available in your choice of{' '}
          <strong className="text-black" data-id="element-281">Black</strong> or{' '}
          <strong className="text-gray-500" data-id="element-282">White</strong> — pick the one your
          kid will actually keep on the backpack.
        </p>
      </div>

      <div className="text-center" data-id="element-283">
        <CTAButton className="w-full sm:w-auto text-lg py-5 px-10" data-id="element-284">
          Check Availability →
        </CTAButton>
      </div>
    </SectionWrapper>;
};